import { Component, OnInit, OnDestroy } from "@angular/core";
import { NavigationService } from "../../providers/navigation.service";
import { ActivatedRoute } from "@angular/router";
import { ApiService } from "../../providers/api.service";
import { Subscription } from "rxjs";
import { SM_CONSTANTS } from "../../shared/constants/sm-constants";
import { ITableColumnHeader } from "../../models/table-column-header";
import { AddServiceComponent } from "src/app/shared/components/add-service/add-service.component";
import { MatDialog } from "@angular/material/dialog";
import { SharedService } from "../../providers/shared.service";
import { UntypedFormControl } from "@angular/forms";
import { AddServiceTemplateItemComponent } from "src/app/shared/components/add-service-template-item/add-service-template-item.component";
import { AddServiceTimingsComponent } from "src/app/shared/components/add-service-timings/add-service-timings.component";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { MessagingService } from "src/app/providers/messaging.service";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { RenewBusinessComponent } from "src/app/shared/components/renew-business/renew-business.component";
import { AddEmployeeSalarySettingComponent } from "src/app/shared/components/add-employee-salary-setting/add-employee-salary-setting.component";
import { TranslateService } from "@ngx-translate/core";
import { DialogService } from "src/app/providers/dialog.service";

@Component({
  selector: "sm-employee-salary-settings",
  templateUrl: "./employee-salary-settings.component.html",
  styleUrls: ["./employee-salary-settings.component.scss"],
})
export class EmployeeSalarySettingsComponent implements OnInit, OnDestroy {
  entityHashId: string = "";
  employeeHash: string = "";
  serviceType: string = "";
  public loader: boolean = false;
  serviceTimings: any = [];
  finalServiceTimings: any = [
    {
      dayName: "Entity Monthly Plan",
      openTime: "28 Nov, 2023",
      closeTime: "27 Dec, 2023",
      status: "Active",
    },
  ];
  salaryData: any[] = [];
  private _apiSubscription: Subscription;
  datalength!: number;
  public page: number = 1;
  searchString: UntypedFormControl = new UntypedFormControl("");

  daysOfWeek = [
    { day: 1, name: "Sunday" },
    { day: 2, name: "Monday" },
    { day: 3, name: "Tuesday" },
    { day: 4, name: "Wednesday" },
    { day: 5, name: "Thursday" },
    { day: 6, name: "Friday" },
    { day: 7, name: "Saturday" },
  ];

  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant(
        "employee_salary_settings.column_headers.pay_type"
      ),
      columnProperty: "payType1",
    },
    {
      columnName: this.translateService.instant(
        "employee_salary_settings.column_headers.pay_rate"
      ),
      columnProperty: "payRate",
    },
    {
      columnName: this.translateService.instant(
        "employee_salary_settings.column_headers.paid_on"
      ),
      columnProperty: "paidOn1",
    },
    {
      columnName: this.translateService.instant(
        "employee_salary_settings.column_headers.net_payment"
      ),
      columnProperty: "netPayment",
    },
    {
      columnName: this.translateService.instant(
        "employee_salary_settings.column_headers.other_perks"
      ),
      columnProperty: "otherPerks",
    },
    {
      columnName: this.translateService.instant(
        "employee_salary_settings.column_headers.perks_type"
      ),
      columnProperty: "perksType",
    },
    {
      columnName: this.translateService.instant(
        "employee_salary_settings.column_headers.deduction"
      ),
      columnProperty: "deduction",
    },
    {
      columnName: this.translateService.instant(
        "employee_salary_settings.column_headers.deduction_type"
      ),
      columnProperty: "deductionType",
    },
  ];

  constructor(
    private _navService: NavigationService,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    private _modelRef: MatDialog,
    private sharedService: SharedService,
    private loaderservice: LoaderServiceService,
    private messagingService: MessagingService,
    private angularFireMessaging: AngularFireMessaging,
    private translateService: TranslateService, 
    private dialogService:DialogService
  ) {
    this._navService.hideSidebarAndNav = false;
    // this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
    //   this.ngOnInit();
    // })

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (resData.responseType === SM_CONSTANTS.RESULT_API_GET_SALARY_INFO) {
        this.salaryData = [];
        if (resData.result) {
          resData.result.forEach((element: any) => {
            if (element.payType == 1) {
              element.payType1 = "hourly";
            } else if (element.payType == 2) {
              element.payType1 = "daily";
            } else if (element.payType == 3) {
              element.payType1 = "weekly";
            } else if (element.payType == 4) {
              element.payType1 = "monthly";
            }

            if (element.paidOn == 1) {
              element.paidOn1 = "daily";
            } else if (element.paidOn == 2) {
              element.paidOn1 = "weekly";
            } else if (element.paidOn == 3) {
              element.paidOn1 = "monthly";
            }
            this.salaryData.push(element);
          });
        }
        this.loader = false;
        this.loaderservice.showLoader = false;
      }
      if (resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_SALARY_INFO) {
        if (resData.result) {
          this.loaderservice.showLoader = false;
          this.ngOnInit();
        }
      }
    });
    if (
      !localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == "null"
    ) {
      this.messagingService.requestPermission();
    }
    this.translateService.onLangChange.subscribe(() => {
      // Update your column headers when the language changes
      this.updateColumnHeaders();
    });
  }
  private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column, index) => {
      let data = [
        "pay_type",
        "pay_rate",
        "paid_on",
        "net_payment",
        "other_perks",
        "perks_type",
        "deduction",
        "deduction_type",
      ];

      // Update each column header with the translated value
      column.columnName = this.translateService.instant(
        `employee_salary_settings.column_headers.${data[index]}`
      );
    });
  }
  // private modelSubscription: Subscription = new Subscription();
  ngOnInit(): void {
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash;
      this.employeeHash = data.employeeHash;
    });
    this.loader = true;
    this.loaderservice.showLoader = true;
    this._apiService.getSalaryInfo(this.employeeHash, "1");
  }

  createNotification(title: any, text: any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  onCreateNewService() {
    this._modelRef.open(AddServiceComponent, {
      width: "700px",
      data: {
        title: "Add service",
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
      },
    });
  }
  onCreateNewServiceFromTemplate() {
    this._modelRef.open(AddServiceTemplateItemComponent, {
      width: "1000px",
      data: {
        title: "Add service From Template",
        ref: this._modelRef,
      },
    });
  }

  openAddTime(rowvalue: any) {
    rowvalue.serviceType = this.serviceType;
    rowvalue.entityHash = this.entityHashId;
    this._modelRef.open(AddServiceTimingsComponent, {
      width: "500px",
      data: {
        title: "Add service timing",
        ref: this._modelRef,
        data: rowvalue,
      },
    });
  }

  removeTime(rowvalue: any) {
    if (this.serviceType == "0") {
      let data = {
        homeServiceTimeInfo: {
          timeList: [
            {
              hashId: rowvalue.hashId,
              status: 2,
            },
          ],
        },
      };
      this._apiService.updateHomeServiceTimeInfo(this.entityHashId, data);
    } else if (this.serviceType == "1") {
      let data = {
        entityTimeInfo: {
          timeList: [
            {
              hashId: rowvalue.hashId,
              status: 2,
            },
          ],
        },
      };
      this._apiService.updateEntityShopTimeInfo(this.entityHashId, data);
    }
  }

  deactivateService(rowvalue: any) {
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 7,
      },
    };

    this._apiService.addUpdateServiceType(metadata, this.entityHashId);

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  activateService(rowvalue: any) {
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 1,
      },
    };

    this._apiService.addUpdateServiceType(metadata, this.entityHashId);

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  deleteService(rowvalue: any) {
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        isDelete: 1,
      },
    };

    this._apiService.addUpdateServiceType(metadata, this.entityHashId);

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  onEdit(rowvalue: any) {
    this._modelRef.open(AddServiceComponent, {
      width: "700px",
      data: {
        title: "Add service",
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
        data: rowvalue,
      },
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    // this.clickEventSubscription.unsubscribe();
    // this.modelSubscription.unsubscribe();
  }

  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;

    //this._apiService.getServices(this.entityHashId, this.page.toString())
  }

  firstTimeBelow3: boolean = false;

  searchServiceData() {
    if (this.searchString.value.length >= 3) {
      this.firstTimeBelow3 = true;
      this.page = 1;
      this._apiService.getServiceDataByKeyword(
        this.entityHashId,
        this.page,
        this.searchString.value
      );
    } else {
      if (this.firstTimeBelow3) {
        this.firstTimeBelow3 = false;
        this.page = 1;
        //this._apiService.getServices(this.entityHashId, this.page.toString())
      }
    }
  }

  reset() {
    this.searchString.reset();
    this.page = 1;
    //this._apiService.getServices(this.entityHashId, this.page.toString())
  }

  renewBusiness() {
    this._modelRef.open(RenewBusinessComponent, {
      width: "500px",
      data: {
        title: "Recharge Business",
        ref: this._modelRef,
        data: this.entityHashId,
      },
    });
  }

  addSalarySetting() {
    let data = {
      title: "Salary Setting",
      ref: this._modelRef,
      data: {
        editMode: false,
        employeeHash: this.employeeHash,
      },
    } ;
    this.dialogService.openFullScreenDialog(AddEmployeeSalarySettingComponent,data);
  }
  editSalary(rowvalue: any) {
    let data = {
      title: "Salary Setting",
      ref: this._modelRef,
      data: {
        editMode: true,
        employeeHash: this.employeeHash,
        settingsData: rowvalue,
      },
    };
    this.dialogService.openFullScreenDialog(AddEmployeeSalarySettingComponent, data);
  }

  convertTo12HourFormat(timeString: any) {
    const [hours, minutes] = timeString.split(":");
    let period = "AM";
    let hour = parseInt(hours, 10);

    if (hour >= 12) {
      period = "PM";
      if (hour > 12) {
        hour -= 12;
      }
    }

    return `${hour.toString().padStart(2, "0")}:${minutes} ${period}`;
  }
}
